import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Pain.module.css';
import { DBDropDown } from '_components';


class PatientCareCenterNoteWpSubjectivePain extends React.Component {

    render() {
        return (
            <PatientCareCenterNoteSection id='sub_pain' name='Pain Rating' level={5}>
                <div className={styles.rating_row}>
                    <label className={this.props.noteType === 2 || this.props.noteType === 4 ? styles.rating_label : styles.rating_label_req}>Best:</label>
                    <DBDropDown
                        className={styles.rating_drop_down}
                        noteId={this.props.noteId}
                        entity={this.props.table}
                        entityKeyColumn={this.props.prefix + 'NO'}
                        entityKeyValue={this.props.pk}
                        field={this.props.prefix + 'SUBPAINBEST'}
                        masterEntity='PTMASTERPAINRATING'
                        masterEntityKeyColumn='PRNO'
                        masterEntitySort='PRORDER'
                        masterEntityDisplay='PRNAME'
                    />

                    <label className={this.props.noteType === 2 || this.props.noteType === 4 ? styles.rating_label : styles.rating_label_req}>Worst:</label>
                    <DBDropDown
                        className={styles.rating_drop_down}
                        noteId={this.props.noteId}
                        entity={this.props.table}
                        entityKeyColumn={this.props.prefix + 'NO'}
                        entityKeyValue={this.props.pk}
                        field={this.props.prefix + 'SUBPAINWORST'}
                        masterEntity='PTMASTERPAINRATING'
                        masterEntityKeyColumn='PRNO'
                        masterEntitySort='PRORDER'
                        masterEntityDisplay='PRNAME'
                    />
                    <label className={this.props.noteType === 4 ? styles.rating_label : styles.rating_label_req}>Current:</label>
                    <DBDropDown
                        className={styles.rating_drop_down}
                        noteId={this.props.noteId}
                        entity={this.props.table}
                        entityKeyColumn={this.props.prefix + 'NO'}
                        entityKeyValue={this.props.pk}
                        field={this.props.prefix + 'SUBPAINCURRENT'}
                        masterEntity='PTMASTERPAINRATING'
                        masterEntityKeyColumn='PRNO'
                        masterEntitySort='PRORDER'
                        masterEntityDisplay='PRNAME'
                    />

                </div>

            </PatientCareCenterNoteSection>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let prefix = noteType === 1 ? 'EV' : 'NT';
    let table = noteType === 1 ? 'PTEVAL' : 'PTNOTE';

    return {
        noteId,
        noteType,
        pk,
        prefix,
        table
    };
}
const connectedPatientCareCenterNoteWpSubjectivePain = connect(mapStateToProps)(PatientCareCenterNoteWpSubjectivePain);
export { connectedPatientCareCenterNoteWpSubjectivePain as PatientCareCenterNoteWpSubjectivePain };

